"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _checkTypes = _interopRequireDefault(require("check-types"));

var _reactRouterDom = require("react-router-dom");

var _semanticUiReact = require("semantic-ui-react");

var _Colors = require("../00_environment/Colors");

var _Bottom = _interopRequireDefault(require("../01_atoms/Bottom"));

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _Container = _interopRequireDefault(require("../01_atoms/Container"));

var _Element = _interopRequireDefault(require("../01_atoms/Element"));

var _ElementGroup = _interopRequireDefault(require("../01_atoms/ElementGroup"));

var _TitledContainer = _interopRequireDefault(require("../01_atoms/TitledContainer"));

var _PassengerDetails = _interopRequireDefault(require("./PassengerDetails"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PassengerSelectionWidget = function PassengerSelectionWidget(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      translatorForNamespace = _ref.translatorForNamespace,
      saved = _ref.savedPassengers,
      selected = _ref.selectedPassengers,
      numberOfPassengersToSelect = _ref.numberOfPassengers,
      _ref$onPassengerToggl = _ref.onPassengerToggle,
      onPassengerToggle = _ref$onPassengerToggl === void 0 ? function () {} : _ref$onPassengerToggl,
      _ref$onAddPassenger = _ref.onAddPassenger,
      onAddPassenger = _ref$onAddPassenger === void 0 ? function () {} : _ref$onAddPassenger,
      _ref$onConfirm = _ref.onConfirm,
      onConfirm = _ref$onConfirm === void 0 ? function () {} : _ref$onConfirm,
      t = _ref.translator;
  // If there's no passenger in the list,
  // forward directly to the "add passenger" form
  // for simpler UX.
  // FIXME: Should be done in flow control

  /*
  if (!check.nonEmptyArray(saved)) {
     return <Redirect to="/book/passenger-details/add" />;
  }
  */
  var allPassengersSelected = selected.length === numberOfPassengersToSelect;
  return /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
    title: t('Select passengers')
  }, /*#__PURE__*/_react["default"].createElement(_PassengerDetails["default"], {
    title: title,
    subtitle: subtitle,
    translatorForNamespace: translatorForNamespace,
    passengers: selected,
    translator: t
  }), saved.length > 0 && /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    backgroundColor: "white"
  }, saved.map(function (p) {
    var checked = selected.some(function (sp) {
      return sp.id === p.id;
    });
    var disabled = !checked && allPassengersSelected;
    var onClick = disabled ? function () {} : function () {
      onPassengerToggle(p);
    };
    return /*#__PURE__*/_react["default"].createElement(_Element["default"], {
      key: p.id,
      onClick: onClick
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Checkbox, {
      checked: checked,
      label: "".concat(p.firstName, " ").concat(p.lastName),
      style: {
        marginRight: 15
      },
      disabled: disabled
    }));
  })), /*#__PURE__*/_react["default"].createElement(_Bottom["default"], null, selected.length < numberOfPassengersToSelect && /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onAddPassenger,
    fluid: true,
    style: {
      marginBottom: 15
    },
    color: _Colors.thirdColor
  }, t('Add passenger'))), /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onConfirm,
    fluid: true,
    primary: true,
    disabled: !allPassengersSelected
  }, t('Confirm')))));
};

var _default = PassengerSelectionWidget;
exports["default"] = _default;